import { render, staticRenderFns } from "./SexManageView.vue?vue&type=template&id=6d5254b6&scoped=true"
import script from "./SexManageView.vue?vue&type=script&lang=js"
export * from "./SexManageView.vue?vue&type=script&lang=js"
import style0 from "./SexManageView.vue?vue&type=style&index=0&id=6d5254b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5254b6",
  null
  
)

export default component.exports